
const customSelects = document.querySelectorAll('.input-wrapper-custom-select');
customSelects.forEach(select=>{
    const selectTrigger = select.querySelector('button');
    const dropdown = select.querySelector('.input-wrapper-custom-select-content');
    const checkboxes = select.querySelectorAll('input[type="checkbox"]');

    const label = selectTrigger.querySelector('span').innerText;

    // Add ARIA attributes
    selectTrigger.setAttribute('aria-haspopup', 'true');
    selectTrigger.setAttribute('aria-expanded', 'false');
    selectTrigger.setAttribute('aria-label', label);

    dropdown.setAttribute('role', 'listbox');
    dropdown.setAttribute('aria-multiselectable', 'true');
    dropdown.id = 'services-dropdown-' + Math.random().toString(36).slice(2, 11);
    selectTrigger.setAttribute('aria-controls', dropdown.id);


    // Toggle dropdown
    selectTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = select.classList.contains('active');
        if (!isExpanded) {
            // Opening
            dropdown.style.visibility = 'visible'; // Make visible immediately
            select.classList.add('active');
            selectTrigger.setAttribute('aria-expanded', 'true');
        } else {
            // Closing
            select.classList.remove('active');
            selectTrigger.setAttribute('aria-expanded', 'false');

            // Add visibility: hidden after transition completes
            setTimeout(() => {
                if (!select.classList.contains('active')) {
                    dropdown.style.visibility = 'hidden';
                }
            }, 300); // Match your transition duration
        }
    });

    // Initial state - hidden
    dropdown.setAttribute('aria-hidden', 'true');
    dropdown.style.visibility = 'hidden';
})
